exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-box[data-v-721475a6]{box-shadow:0 -2px 13px 0 #9e9e9e}@media screen and (min-width:768px){.price-box[data-v-721475a6]{box-shadow:none}}", ""]);

// exports
